import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "widget" }
const _hoisted_2 = { class: "sailing-updates" }
const _hoisted_3 = {
  key: 0,
  class: "sailing-updates__tabs"
}

import { VCard, VRadio } from "v-ferry-components";
import { ref, watch } from "vue";
import SailingUpdates from "./components/SailingUpdates.vue";
import useRoutesQuery from "./composables/useRoutesQuery";
import SvgSprite from "@/components/icons/SvgSprite.vue";
import "@/css/style.scss";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const { data: routes } = useRoutesQuery();

const active = ref(1);

watch(routes, (c) => {
    if (c) {
        active.value = c[0].id;
    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SvgSprite),
    _createElementVNode("div", _hoisted_2, [
      (_unref(routes))
        ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(routes), (route, index) => {
              return (_openBlock(), _createElementBlock("li", { key: index }, [
                _createVNode(_unref(VRadio), {
                  modelValue: active.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((active).value = $event)),
                  name: "route",
                  id: route.id,
                  value: route.id
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(route.routeName), 1)
                  ]),
                  _: 2
                }, 1032, ["modelValue", "id", "value"])
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createVNode(_unref(VCard), {
        unelevated: "",
        bordered: ""
      }, {
        default: _withCtx(() => [
          _createVNode(SailingUpdates, { selectedRoute: active.value }, null, 8, ["selectedRoute"])
        ]),
        _: 1
      })
    ])
  ]))
}
}

})